module.exports = __webpack_public_path__ + "static/img/lj-pub-logo-desktop.48f2280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileimg/lj-pub-logo-desktop.png
// module id = BmGa
// module chunks = 22